var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import BaseModel from './BaseModel';
import { valuesIn, find, filter, flatMapDeep, uniqWith } from 'lodash';
import MasterOptionExceptionModel from './MasterOptionExceptionModel';
import { includes } from 'lodash';
var OptionExceptionModel = /** @class */ (function (_super) {
    __extends(OptionExceptionModel, _super);
    function OptionExceptionModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.parentId = hydrated.parentId;
        _this.name = hydrated.name;
        _this.masterOption = hydrated.masterOption;
        _this.options = hydrated.options;
        _this.__mc = 'OptionExceptionModel';
        return _this;
    }
    // TODO this data needs more abstracting
    // "default_choices" should have it's own model for
    // portability and flexibility.
    OptionExceptionModel.prototype.getIncludedDefault = function () {
        var defaultChoices = this.masterOption.defaultChoices;
        var included = find(defaultChoices, function (choice) {
            return choice.included === true;
        });
        return included;
    };
    OptionExceptionModel.prototype.getIncludedDefaults = function () {
        var defaultChoices = this.masterOption.defaultChoices;
        // all choices are included
        if (this.masterOption.allChoicesIncluded()) {
            return defaultChoices;
        }
        var includedChoices = filter(defaultChoices, function (choice) {
            return choice.included === true;
        });
        return includedChoices;
    };
    OptionExceptionModel.prototype.getIncludedDefaultChoiceIds = function () {
        var includedDefaults = this.getIncludedDefaults();
        var choiceIds = flatMapDeep(includedDefaults, function (choice) {
            return choice.gcid;
        });
        return choiceIds;
    };
    OptionExceptionModel.prototype.getIncludedChoices = function (option) {
        var includedChoices = flatMapDeep(option.choices, function (choice) {
            if (choice.included) {
                return choice;
            }
            return null;
        });
        includedChoices = filter(includedChoices, function (includedChoice) {
            return (includedChoice !== null);
        });
        return includedChoices;
    };
    OptionExceptionModel.prototype.getMasterDefaults = function () {
        var defaultChoices = this.masterOption.defaultChoices;
        var defaultsArray = flatMapDeep(defaultChoices);
        return defaultsArray;
    };
    OptionExceptionModel.prototype.getIncludedChoiceForOption = function (optionId) {
        var option = this.options[optionId];
        if (!option) {
            if (optionId === this.id) {
                return this.getMasterDefaults();
            }
            return null;
        }
        var included = this.getIncludedDefault();
        included = included || this.getIncludedChoices(option);
        var choices = option.choices;
        var includedChoices = filter(choices, function (choice) {
            return (choice.gcid === included.gcid) && (choice.included === true);
        });
        if (includedChoices.length === 0) {
            includedChoices = uniqWith(included, function (choiceA, choiceB) {
                return choiceA.ocid === choiceB.ocid;
            });
        }
        return includedChoices;
    };
    // there are times when options have the ID of the franchise level and we need local
    OptionExceptionModel.prototype.convertFranchiseOptionIdsToLocal = function () {
        if (!includes(this.id.toString(), 'f')) {
            this.id = "f" + this.id;
            if (this.masterOption) {
                this.masterOption.id = this.id;
            }
        }
    };
    OptionExceptionModel.prototype.hydrate = function (data) {
        var optionException = {};
        // TODO clean up model so the data is less redundant and in one place.
        var itemId = data[0];
        var optionExceptionRaw = data[1];
        var exceptionRules = valuesIn(optionExceptionRaw).pop();
        optionException['parentId'] = "" + itemId;
        optionException['id'] = "" + exceptionRules.option_id;
        optionException['masterOption'] = new MasterOptionExceptionModel(exceptionRules.master_option || __assign({}, exceptionRules, { hydrationStrategy: "hydrate" }));
        optionException['options'] = {};
        if (exceptionRules.options) {
            for (var id in exceptionRules.options) {
                optionException['options'][id] = new MasterOptionExceptionModel(exceptionRules.options[id]);
            }
        }
        optionException['name'] = null;
        return optionException;
    };
    OptionExceptionModel.prototype.hydrateForCoupon = function (data) {
        var optionException = {};
        optionException['id'] = "" + data.option_id;
        optionException['masterOption'] = new MasterOptionExceptionModel(data.master_option || __assign({}, data, { hydrationStrategy: "hydrate" }));
        optionException['options'] = {};
        if (data.options) {
            for (var id in data.options) {
                optionException['options'][id] = new MasterOptionExceptionModel(data.options[id]);
            }
        }
        optionException['name'] = null;
        return optionException;
    };
    OptionExceptionModel.prototype.hydrateFromStore = function (data) {
        var optionException = {};
        optionException = data;
        return optionException;
    };
    return OptionExceptionModel;
}(BaseModel));
export default OptionExceptionModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/OptionExceptionModel.ts
// module id = aYau
// module chunks = 18